// PrivacyPolicy.js
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy for Ball to Cup</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: April 22, 2025</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. No Personal Data Collection</h2>
        <p>We do <strong>not collect</strong>, store, or share any personally identifiable information such as your name, email address, or phone number when you use the App.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Non-Personal Usage Data</h2>
        <p>We may collect <strong>non-personal</strong> data such as gameplay statistics or crash logs using third-party tools (e.g., Google AdMob, Apple services) to improve performance and user experience. This data does <strong>not identify you personally</strong>.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. Advertising</h2>
        <p>The App may display <strong>third-party advertisements</strong> (e.g., from Google AdMob). These services may use anonymized data like device type or interaction behavior to show relevant ads.</p>
        <p>Google’s privacy policy: <a href="https://policies.google.com/privacy" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Children’s Privacy</h2>
        <p>The App is intended for a general audience and does <strong>not knowingly collect</strong> data from children under 13.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. Data Security</h2>
        <p>Although we do not collect personal data, we take reasonable precautions to protect the anonymized usage data processed by the app.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Changes to This Policy</h2>
        <p>We may update this Privacy Policy occasionally. Any changes will be shown on this page with a new "Last updated" date.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Contact</h2>
        <p>If you have questions or concerns about this Privacy Policy, please contact us at: <br />
          <strong>hi@n1inovasyon.com</strong>
        </p>
      </section>

      <section className="mt-10 border-t pt-4 text-center text-gray-600 text-sm">
        <p>Ball to Cup is a simple game. We respect your privacy and keep things minimal and safe.</p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
